export default "__VITE_ASSET__Cd7tMbHD__"